import { type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { NotificationsContext } from "@/contexts/notifications-context";
import { useGlobalNotifications } from "@/hooks/useGlobalNotifications";

export const NotificationsProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const value = useGlobalNotifications(location.pathname.startsWith("/admin"));
  return <NotificationsContext.Provider value={value}>{children}</NotificationsContext.Provider>;
};
